<main id="cases-container">
  <payee-cases
    [getCasesPath]="getCasesPath"
    [getDebtorsPath]="getDebtorsPath"
    [showInfo]="false"
    [showTodoSubTabs]="true"
    [additionalColumns]="additionalColumns"
    [additionalActions]="$any(additionalActions)"
    [additionalFilters]="additionalFilters"
    [searchClients]="searchClients"
    [resolveClient]="resolveClient"
    [allowDelete]="true"
    [allowEdit]="false"
  ></payee-cases>
</main>
